export const projectTypeConstants = [
  { name: "Fixed", value: "fixed" },
  { name: "Monthly", value: "monthly" },
];
